import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Sandbox dimension for manually testing DMS attribute types (e.g. ' +
      'Files) in isolation from production data models',
    name: 'Files Playground',
    partialId: PartialId.Standard.create('files_playground'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
